import React from 'react'
import Header from './Header'
import Main from './Main'
import Footer from './Footer'

export default class Container extends React.Component {
  state={}
  render() {
    return (
      <React.Fragment>
        <Header />
        <Main />
        <Footer />
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/component/Container.js